import { useRef, useEffect } from "react";

const COLORS = [
  { r: 201, g: 168, b: 76 },
  { r: 155, g: 114, b: 207 },
];

function createParticle(canvas) {
  return {
    x: Math.random() * canvas.width,
    y: Math.random() * canvas.height,
    size: Math.random() * 1.8 + 0.4,
    speed: Math.random() * 0.35 + 0.08,
    opacity: Math.random() * 0.14 + 0.04,
    color: COLORS[Math.floor(Math.random() * 2)],
    dx: (Math.random() - 0.5) * 0.12,
  };
}

function updateParticle(p, canvas, mouse) {
  const dx = mouse.x - p.x;
  const dy = mouse.y - p.y;
  const dist = Math.sqrt(dx * dx + dy * dy);
  if (dist < 160 && dist > 0) {
    p.x += (dx / dist) * 0.25;
    p.y += (dy / dist) * 0.25;
  }
  p.x += p.dx;
  p.y -= p.speed;
  if (p.y < -6) {
    p.y = canvas.height + 6;
    p.x = Math.random() * canvas.width;
  }
  if (p.x < -6) p.x = canvas.width + 6;
  if (p.x > canvas.width + 6) p.x = -6;
}

export default function ParticleCanvas({ density = 1 }) {
  const canvasRef = useRef(null);
  const stateRef = useRef({ particles: [], mouse: { x: -1000, y: -1000 }, raf: null });

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    const state = stateRef.current;

    const initCanvas = () => {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
      const count = Math.floor(150 * density);
      state.particles = Array.from({ length: count }, () => createParticle(canvas));
    };
    initCanvas();

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      state.particles.forEach((p) => {
        updateParticle(p, canvas, state.mouse);
        const { r, g, b } = p.color;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(${r},${g},${b},${p.opacity})`;
        ctx.fill();
      });
      state.raf = requestAnimationFrame(animate);
    };
    animate();

    const handleResize = () => initCanvas();
    const handleMove = (e) => {
      state.mouse = { x: e.clientX, y: e.clientY };
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("mousemove", handleMove);

    return () => {
      cancelAnimationFrame(state.raf);
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("mousemove", handleMove);
    };
  }, [density]);

  return (
    <canvas
      ref={canvasRef}
      className="absolute inset-0 w-full h-full pointer-events-none"
    />
  );
}
